/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';

type BestPricingNotEligibleComponentProps = {
  successHandler: () => void;
}

export default function BestPricingNotEligibleComponent(props: BestPricingNotEligibleComponentProps) {
  return (
    <React.Fragment>
      <Paper elevation={0}>
        <Box p={5}>
          <PageSubTitleViewComponent id="page.bestPricing.notEligible.title" />

          <Typography variant="body1">
            <IntlMessageComponent id="page.bestPricing.notEligible.text" />
          </Typography>

          <Box mt={5}>
            <ButtonComponent
              color="primary"
              variant="contained"
              onClick={props.successHandler}
            ><IntlMessageComponent id="general.retry" /></ButtonComponent>
          </Box>
        </Box>
      </Paper>
    </React.Fragment>
  );
}
